import { useMemo } from "react";

const noopPredicate = () => true;
const noopNormalize = (item) => item;

export const baseSearchTransform = ({
  items,
  searchUtils,
  customPredicate,
  normalizeItem = noopNormalize,
}) => {
  const { match, highlightHit } = searchUtils;
  if (items) {
    const transformedItems = items.reduce((acc, rawItem) => {
      const item = normalizeItem(rawItem);

      const extraPredicate = customPredicate || noopPredicate;
      if (!match(item.title) || !extraPredicate(item)) {
        return acc;
      }

      const { slug, title, ...other } = item;
      const newItem = {
        ...other,
        label: title,
        href: slug,
        id: item.an || item.slug,
        displayLabel: highlightHit(title),
      };

      acc.push(newItem);
      return acc;
    }, []);

    return transformedItems;
  }
};

export const useBaseSearchTransform = ({
  items,
  searchUtils,
  normalizeItem,
  customPredicate,
}) => {
  const transformedItems = useMemo(
    () =>
      baseSearchTransform({
        items,
        searchUtils,
        normalizeItem,
        customPredicate,
      }),
    [items, searchUtils, normalizeItem, customPredicate]
  );

  return transformedItems;
};
